import React, { useEffect, useState } from "react";
import { fabric } from "fabric";
import apiClient from "../../api/client";
import { useNavigate, useNavigation } from "react-router-dom";
import { Stepper } from "@material-ui/core";

const Fabricfile = ({ refFunction, stepperFormdata, refaddTriangle }) => {
  const [image, setImage] = useState(null);
  const [imageCoords, setImageCoords] = useState(1);
  const [canvas, setCanvas] = useState(null);
  const [resultLink, setResultLink] = useState("");
  refFunction.current = getModifiedCanvasBase64;
  refaddTriangle.current = addTriangle;
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    coords: "",
    pattern: null, // Assuming pattern is a file
    original_file: null, // Assuming original_file is a file
  });
  // const handleChange = (e) => {
  //   const { name, value, files } = e.target;
  //   setFormData({
  //     ...formData,
  //     [name]: files ? files[0] : value
  //   });
  // };

  const handlePatternFileChange = (file) => {
    setFormData((prevState) => ({
      ...prevState,
      pattern: file,
    }));
  };

  useEffect(() => {
    const newCanvas = new fabric.Canvas("c", {
      height: 400,
      width: 400,
      preserveObjectStacking: true,
      backgroundColor: "white",
    });

    setCanvas(newCanvas);

    imageUpload(newCanvas);
  }, []);
  async function urlToBlob(url) {
    const response = await fetch(url);
    const blob = await response.blob();
    return blob;
  }
  async function imageUpload(newCanvas) {
    var file = stepperFormdata?.file;
    // const file = 'https://example.com/image.jpg';
    const filename = "image.jpg";
    const mimeType = "image/jpeg";

    // urlToFile(file, filename, mimeType)
    //     .then(file => {
    //     })
    //     .catch(error => {
    //         console.error('Error converting URL to file:', error);
    //     });
    // var file = e.target.files[0];

    setFormData((prevState) => ({
      ...prevState,
      original_file: file,
    }));

    const blob = await urlToBlob(file);
    let fileData =
      typeof stepperFormdata?.file === "string" ? blob : stepperFormdata?.file;

    const reader = new FileReader();
    reader.readAsDataURL(fileData);
    reader.onload = () => {
      const base64data = reader.result;
      fabric.Image.fromURL(base64data, function (img) {
        let uploadImg;
        let scale = newCanvas.width / img.width;
        setImageCoords(img.width / newCanvas.width);
        uploadImg = img.set({
          left: 0,
          top: 0,
          scaleX: scale,
          scaleY: scale,
        });
        newCanvas.setDimensions({
          height: uploadImg.height * scale,
          width: uploadImg.width * scale,
        });
        newCanvas.renderAll();
        newCanvas.add(uploadImg);
        newCanvas.requestRenderAll();
      });
    };
  }

  function addTriangle() {
    // e.preventDefault();
    var rect = new fabric.Rect({
      left: 0,
      top: 0,
      width: 50,
      height: 50,
      fill: "transparent",
      stroke: "red",
      strokeWidth: 2,
      strokeUniform: true,
      strokeFill: "black",
      padding: 0,
    });
    canvas.add(rect);
    canvas.renderAll();
  }

  const ImageFull = (e) => {
    const { imageURL, rectObj } = getModifiedCanvasBase64();

    download(imageURL);
    function download(dataURL) {
      var dl = document.createElement("a");
      document.body.appendChild(dl); // This line makes it work in Firefox.
      dl.setAttribute("href", dataURL);
      dl.setAttribute("download", "demo.png");
      dl.click();
    }
  };

  function getModifiedCanvasBase64() {
    let rectObj;
    let multiplier = imageCoords;
    let tempCanvas = new fabric.Canvas(null, {
      width: canvas.width * multiplier,
      height: canvas.height * multiplier,
      backgroundColor: canvas.backgroundColor,
    });

    for (const object of canvas.getObjects()) {
      let item = fabric.util.object.clone(object);

      item.scaleX *= multiplier;
      item.scaleY *= multiplier;

      item.left *= multiplier;
      item.right *= multiplier;
      item.top *= multiplier;
      item.bottom *= multiplier;

      if (item.type === "rect") rectObj = item;
      tempCanvas.add(item);
      tempCanvas.renderAll();
    }

    tempCanvas.renderAll();
    const imageURL = tempCanvas.toDataURL({
      format: "png",
      quality: 1.0,
    });

    return { imageURL, rectObj };
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const { imageURL, rectObj } = getModifiedCanvasBase64();
    const coords = rectObj.lineCoords;

    const formdataObj = new FormData();
    formdataObj.append("coords", JSON.stringify(coords));
    formdataObj.append("original_file", formData.original_file);
    formdataObj.append("pattern", formData.pattern);
    const result = apiClient.post("/mockups/", formdataObj);

    // if(result.ok){
    //   const jsonData =  result.json();
    // }
    // const image = result?.data?.file;
    // navigate(`/previewparams={{ testvalue: "hello" }}`);
    // navigate(`/previewparams={{ testvalue: "hello" }}`);
    // navigate('/preview', { src: { src: 'image' } });
    // navigation.navigate('/preview', { src: 'image' });

    result.then((data) => {
      setResultLink();
    });
  };

  return (
    <div style={{ padding: "2rem" }}>
      <form onSubmit={handleSubmit}>
        <div className="d-flex gap-3">
          {/* <button className="btn btn-primary mb-2"  onClick={addTriangle}>
        add Triangle
      </button> */}

          {/* <button className="btn btn-primary" onClick={addTriangle}>
        add Triangle
      </button> */}
        </div>

        {/* <div className="col-md-4 my-2">
     <input type="text" 
     class="form-control" id="coords" placeholder="cords"aria-describedby="basic-addon1"
     onChange={(e)=>handleCoordsChange("coords", e.target.value)} 
     />
     </div> */}

        <div>
          <canvas id="c" />
        </div>

        <div className="my-3">
          {/* <button className="btn btn-primary"
      style={{backgroundColor:"blue"}}
     
      type="submit"
      >
        submit
      </button> */}
        </div>
      </form>

      {/* <img src={resultLink} alt="Result" /> */}
    </div>
  );
};

export default Fabricfile;
